'use client';

import { useIntl } from 'react-intl';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { addRatingCallToActionMessages } from './AddRatingCallToAction.messages';

const roundedClasses = 'h-4 w-4 rounded-full border p-2 border-color-grey-dark box-content';

export type AddRatingCallToActionProps = {
  /* 
    onAction - handler function that will be executed after a component action
  */
  onAction: () => void;
  /* 
    isLoading - indicates if the component should be rendered in loading state (Skeleton mode)
  */
  isLoading?: boolean;
};

/**
 * The AddRatingCallToAction component is used to display a call to action for the user
 * to write a new rating/review
 */
export const AddRatingCallToAction = ({
  onAction,
  isLoading = false,
  ...props
}: AddRatingCallToActionProps) => {
  const { formatMessage } = useIntl();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
    }
  };

  return (
    <div
      className="border-color-grey flex flex-col items-center justify-center gap-1 rounded-sm border border-dashed px-1.5 pb-3 pt-4"
      {...props}
    >
      <button
        onClick={handleAction}
        type="button"
        className="group flex flex-col items-center gap-1"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Skeleton className={roundedClasses} />
            <Skeleton className="h-3 w-[10rem]" />
          </>
        ) : (
          <>
            <span className={`${roundedClasses} group-hover:bg-color-grey-light block`}>
              <span className="icon-emp-plus h-full w-full" />
            </span>
            <span>{formatMessage(addRatingCallToActionMessages.text)}</span>
          </>
        )}
      </button>
    </div>
  );
};
